import {
  CreativeTagEvent,
  ViewabilityEventConditions,
  ViewabilityEnvironment
} from '../enums';
import { EventEmitter } from '../types';
import { ViewabilityObserver } from '../types/viewability-observer';

export class LoadedEventNotifier {
  private isEventEmitted = false;
  constructor(
    observer: ViewabilityObserver,
    private readonly emitter: EventEmitter<CreativeTagEvent>
  ) {
    if (observer.environment === ViewabilityEnvironment.InApp) {
      observer.on(ViewabilityEventConditions.On100PercentVisible, () =>
        this.handleEvent()
      );
    } else {
      this.handleEvent();
    }
  }
  private handleEvent() {
    if (!this.isEventEmitted) {
      this.emitter.emit(CreativeTagEvent.CreativeLoaded);
      this.isEventEmitted = true;
    }
  }
}
